import {match} from 'ts-pattern';

import {last, sortBy} from 'ramda';

import {DrillDownStatistics} from '@dms/api/core';

import {OTHER_LEVEL_VALUE} from '../constants/OTHER_LEVEL_VALUE';

const VAT_RECLAIMABLE_ORDER = ['true', 'false'];

const getRank = (row: DrillDownStatistics): number => {
  const level = last(row.levels);

  return match(level?.name)
    .with('vat_reclaimable', () =>
      level?.value === OTHER_LEVEL_VALUE
        ? Number.POSITIVE_INFINITY
        : VAT_RECLAIMABLE_ORDER.indexOf(level?.value ?? '')
    )
    .with('number_of_seats', () =>
      level?.value === OTHER_LEVEL_VALUE ? Number.POSITIVE_INFINITY : Number(level?.value)
    )
    .with('trim_level', () => (level?.value === OTHER_LEVEL_VALUE ? Number.POSITIVE_INFINITY : 0))
    .otherwise(() => 0);
};

/**
 * Rows of the optional levels go Yes / No and by seat count ascending, the "other" bucket last.
 * Rows of the other levels keep the response order, the sort is stable.
 */
export const sortOptionalLevelRows = (rows: DrillDownStatistics[]) => sortBy(getRank, rows);
